<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">EIAJ検収伝票発行</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search" class="btn-search" v-permit.SHARP_EP_SEARCH>{{
          $t('app.buttons.search')
        }}</v-btn>
        <v-btn
          :disabled="selected.length == 0 || selected.length > 1"
          @click="downloadEIAJPdf"
          v-permit.SHARP_EP_EIAJ_DOWNLOAD
          >EIAJ検収伝票</v-btn
        >
        <v-btn
          :disabled="selected.length == 0 || selected.length > 1"
          @click="download"
          v-permit.SHARP_EP_DOCUMENT_DOWNLOAD
          >資料ダウンロード</v-btn
        >
        <v-btn
          :disabled="selected.length == 0 || selected.length > 1"
          @click="reportBySupplier"
          v-permit.SHARP_EP_DELIVERY_DOWNLOAD
          >輸入諸掛費用明細(納入先別)</v-btn
        >
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
        <!-- <v-btn @click="reportTotal" v-permit.SHARP_EP_TOTAL_TABLE_DOWNLOAD>輸入諸掛費用明細(合計表)</v-btn> -->
      </v-card-actions>
    </v-card>
    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    label="納入日"
                    v-model="query.startDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.startDateFrom"
                    label="~"
                    v-model="query.endDateTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="コンテナNO"
                v-model="query.containerNo"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                url="divisions/kv?type=BU"
                v-model="query.buId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field label="D/O NO" v-model="query.doNo" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="納入場所"
                url="warehouses/kv"
                v-model="query.warehouseId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.ivNo')"
                clearable
                v-model="query.invoiceNo"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.blNo')"
                clearable
                v-model="query.blNo"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-checkbox label="未印刷" v-model="query.isPrinted"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="inline-edit"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <!-- <td>{{ props.item.no }}</td> -->
          <td>{{ props.item.partnerName }}</td>
          <td>
            {{ props.item.headquarterCode }}:{{ props.item.headquarterName }}
          </td>
          <td>{{ props.item.doNo }}</td>
          <td>{{ props.item.branchCode }}</td>
          <td>{{ props.item.containerNos }}</td>
          <td>{{ props.item.blNo }}</td>
          <td>{{ props.item.forecastDate }}</td>
          <td>{{ props.item.sjlWarehouseName }}</td>
          <td>{{ props.item.finallyWarehouseName }}</td>
          <td>
            <v-icon v-if="props.item.printed == true">check</v-icon>
            <v-icon v-if="props.item.printed == false">clear</v-icon>
          </td>
          <td>
            <v-icon @click="showPrintHistory(props.item.id)">history</v-icon>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <print-history-dialog
      :history="historyData"
      ref="print"
    ></print-history-dialog>
    <download-doc-dialog
      :blNo="selected.length > 0 ? selected[0].blNo : ''"
      ref="DownloadDocDialog"
    ></download-doc-dialog>
    <document-eiaj-dialog @refresh="load" ref="eiajDlg" />

    <document-by-supplier-dialog ref="docBySupplierDlg" />
    <document-total-dialog ref="docTotalDlg" />
    <eiaj-dialog ref="eiajDialog" />
  </v-container>
</template>

<script>
/* eslint-disable no-console */
import PrintHistoryDialog from './PrintHistoryDialog'
import DownloadDocDialog from '@/components/DownloadDocDialog'
import DatePicker from '@/components/DatePicker'
import DocumentEiajDialog from './DocumentEiajDialog'

import DocumentBySupplierDialog from './DocumentBySupplierDialog'
import DocumentTotalDialog from './DocumentTotalDialog'
import EiajDialog from './EiajDialog'

export default {
  components: {
    DatePicker,
    DocumentEiajDialog,
    PrintHistoryDialog,
    DownloadDocDialog,
    DocumentBySupplierDialog,
    DocumentTotalDialog,
    EiajDialog,
  },
  methods: {
    download() {
      this.$refs.DownloadDocDialog.popup()
    },
    showPrintHistory(id) {
      this.$http.get(`/eiaj-history/${id}`).then((res) => {
        this.historyData = res.data
        this.$refs.print.popup()
      })
    },
    load() {
      this.autoload = true
      return this.$http
        .get('/eiajs/orders', {
          params: {
            ...this.query,
            ...this.$pageable(),
          },
        })
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
    },
    search() {
      this.$storeParams()
      this.pagination.page = 0
      this.load()
    },
    containerNo(item) {
      let cartonNumber = ''
      if (item && item.cartonNumber && item.cartonNumber.size > 0) {
        for (var i = 0; i < item.cartonNumber.length; i++) {
          cartonNumber += item.cartonNumber[i]
          if (i % 2 == 0 && item.cartonNumber[i + 1] != null) {
            cartonNumber += '~'
          }
        }
      }
      return cartonNumber
    },
    downloadEIAJPdf() {
      this.$refs.eiajDialog.popup(this.selected[0].id)
      // this.$http.post(`/eiaj-history/${this.selected[0].id}`)
      // this.load()
      // return this.$download(
      //   `/delivery-orders/${this.selected[0].id}/batch-eiajs.pdf`
      // )
    },

    print() {
      this.$http
        .get(`/eiajs/${this.selected[0].id}/orders`)
        .then((res) => {
          this.$refs.eiajDlg.popup(res.data, this.selected[0].id)
        })
        .catch(() => {
          this.$message('', 'get eiaj failed')
        })
      // let pages = this.selected.map(s => ({
      //   ...s,
      //   cartonNo: this.containerNo(s)
      // }))
    },
    reportBySupplier() {
      this.$http
        .get(`/delivery-orders/do/${this.selected[0].id}?view=reportBySupplier`)
        .then((res) => {
          console.log(res.data)
          this.$refs.docBySupplierDlg.popup([res.data])
          // if (res.data.cannotPrint) {
          //   this.$message(
          //     '',
          //     '該当データは無償DO枝番、費用が按分されないため、この画面のデータはブランクになります'
          //   )
          // } else {
          //   this.$refs.docBySupplierDlg.popup([res.data])
          // }
        })
        .catch((res) => this.$catch(res))
    },
    reportTotal() {
      this.$refs.docTotalDlg.popup([this.shipment])
    },
  },
  data() {
    return {
      results: [],
      loading: false,
      query: {
        isPrinted: false,
      },
      selected: [],
      dialog: {
        show: false,
      },
      historyData: [],
      pagination: {
        page: 1,
      },
      headers: [
        // { text: '検収伝票NO', value: 'no' },
        { text: '海外取引先', value: 'partnerName', sortable: false },
        { text: '事業本部', value: 'buName', sortable: false },
        { text: 'D/O NO', value: 'doNo', sortable: false },
        { text: '枝番', value: 'branchCode', sortable: false },
        { text: 'コンテナNO', value: 'containerNo', sortable: false },
        { text: 'B/L NO', value: 'blNo', sortable: false },
        { text: '納入日 ', value: 'warehousingDate', sortable: false },
        { text: 'SJL納入場所', value: 'sjlWarehouseName', sortable: false },
        {
          text: '最終納入場所',
          value: 'finallyWarehouseName',
          sortable: false,
        },
        { text: '印刷済', value: '', sortable: false },
        { text: '印刷履歴', value: '', sortable: false },
      ],
    }
  },
  mounted() {
    this.$loadParams()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
}
</script>
